import * as _ from 'lodash';

angular.module("tromanWeb").factory('listService', ['ergoDateFilter', function (ergoDateFilter) {

    var so = {};

    so.separator = ';';

    function makeCsvProperty(val) {
        if (val == null) {
            return '';
        } else if (_.isArray(val)) {
            return val.join(', ');
        } else {
            return val.toString();
        }
    }

    function makeCsvRow(row) {
        /// <param name="row" value="['']">An array to convert to a csv row</param>
        var ret = [];
        for (var i = 0; i < row.length; ++i) {
            var str = makeCsvProperty(row[i]);
            str = str.replace('"', '""');
            ret.push('"' + str + '"');
        }
        return ret.join(so.separator);
    }

    function buildTable(list, columnProperties, sortingProperties) {
        /// <param name="list" value="[]">List of items</param>
        /// <returns value="[[]]">An html table definition as a string</returns>

        function getProperty(item, prop) {
            try {
                var val = prop.fn(item);
                if (val == null)
                    return null;
                return val;
            } catch (err) {
                return null;
            }
        }

        function getRow(item) {
            return {
                columns: columnProperties.map(function (prop) { return getProperty(item, prop); }),
                order: sortingProperties.map(function (prop) { return getProperty(item, prop); })
            };
        }

        function compareRow(a, b) {
            var sortprops = sortingProperties;

            for (var i = 0; i < sortprops.length; ++i) {
                var asc = sortprops[i].ascending;
                var av = a.order[i];
                var bv = b.order[i];

                if (av == null || bv == null) {
                    if (av != null) return asc ? 1 : -1;
                    if (bv != null) return asc ? -1 : 1;
                } else {
                    if (av < bv) return asc ? -1 : 1;
                    if (bv < av) return asc ? 1 : -1;
                }
            }

            return 0;
        }

        var rows = list.map(getRow);
        rows.sort(compareRow);
        return rows.map(function (x) { return x.columns; });
    }

    function escapeElementCharacter(ch) {
        if (ch === '&') return '&amp;';
        if (ch === '<') return '&lt;';
        if (ch === '>') return '&gt;';
        if (ch === '"') return '&quot;';
        if (ch === "'") return '&#x27;';
        if (ch === '/') return '&#x2F;';
        throw new Error("Invalid escape");
    }

    function renderValue(val) {
        if (val == null) {
            return '';
        } else {
            var str = val.toString();
            return str.replace(/[&<>"'/]/g, escapeElementCharacter);
        }
    }

    function renderProperty(val) {
        if (_.isArray(val)) {
            return val.map(renderValue).join('<br>');
        } else {
            return renderValue(val);
        }
    }

    so.render = function render(list, lc) {

        var table = buildTable(list, lc.selectedColumns, lc.selectedSorters);

        var headerRow = '<tr><td>' + lc.selectedColumns.map(prop => renderValue(prop.title)).join('</td><td>') + '</td></tr>';
        var tableRows = table.map(row => '<tr><td>' + row.map(renderProperty).join('</td><td>') + '</td></tr>');

        var html = [
            '<header>',
            '<div class="logo"></div>',
            '<h1>',
            renderValue(lc.title) || '',
            '</h1>',
            '<span class="reportdate">',
            ' (' + renderValue(ergoDateFilter(new Date()) || '') + ')',
            '</span>',
            '</header>',
            '<table>',
            '<thead>',
            headerRow,
            '</thead>',
            '<tbody>',
            tableRows.join('\n'),
            '</tbody>',
            '</table>'
        ];

        return html.join('\n');
    };

    so.toCsv = function toCsv(list, lc) {

        var table = buildTable(list, lc.selectedColumns, lc.selectedSorters);

        var header = makeCsvRow(lc.selectedColumns.map(function (prop) { return prop.title; }));
        var rows = table.map(makeCsvRow);
        rows.splice(0, 0, header);

        return rows.join('\r\n');
    };

    return so;

}]);
